import { render, staticRenderFns } from "./WrapFTM.vue?vue&type=template&id=6c547156&"
import script from "./WrapFTM.vue?vue&type=script&lang=js&"
export * from "./WrapFTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports